import { useState, useEffect } from 'react';
import { canUseDOM } from '..';
function useHasClass(selector, className) {
  const [hasClass, setHasClass] = useState(false);
  useEffect(() => {
    if (canUseDOM) {
      const element = document.querySelector(selector);
      if (element) {
        setHasClass(element.classList.contains(className));
      }
      const observer = new MutationObserver(() => {
        if (element) {
          setHasClass(element.classList.contains(className));
        }
      });
      if (element) {
        observer.observe(element, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
      return () => {
        observer.disconnect();
      };
    }
  }, [selector, className]);
  return hasClass;
}
export default useHasClass;